<template>
  <default-layout>
    <vue-headful
      v-if="project && project.name"
      :title="`${project.name} | ${currentPanoramaGroupName}`"
    />
    <v-layout justify-center row wrap>
      <div v-for="(panorama, idx) in panoramasSorted"
           :key="idx"
           class="col-12 pano-link-wrapper"
      >
        <router-link :to="generateRoute($route.params.order, panorama, $route.params.id)">
          <img :src="getCdn(`${panorama.image}?width=1000&height=1000`)"/>
          <div class="pano-link-description">
            <h4>{{ panorama.name }}</h4>
            <p v-html="panorama.description"></p>
          </div>
        </router-link>
      </div>
    </v-layout>
  </default-layout>
</template>
<script>
/* ============
 * Panoramas list Page
 * ============
 *
 * Page where the user can view the account information.
 */
import store from '@/store';
import { mapGetters } from 'vuex';
import { cdnUrl } from '@/utils/urls';
import DefaultLayout from '@/layouts/Default.vue';
import VCard from '@/components/Card.vue';
import VueHeadful from 'vue-headful';

const generateRoute = (order, panorama, id) => ({
  name: 'order.panorama.view',
  params: { order: order, panoramaOrderId: panorama.id, id : id },
  query: { iframeSrc: panorama.url, showBackButton: true },
});

export default {
  name: 'OrderPanoramas',
  components: {
    DefaultLayout,
    VCard,
    VueHeadful,
  },
  data() {
     return {
       panoramasSorted: [],
     }
  },
  watch: {
    '$route.params.id': {
      handler(id) {
        this.panoramasSorted = this.panoramas.filter(pano => pano.page_id == id);
        if (this.panoramasSorted.length === 1) {
          const route = this.generateRoute(this.$route.params.order, this.panoramasSorted[0], this.$route.params.id)
          this.$router.push(route);
        }
      },
      immediate: true,
    },
  },

  computed: {
    ...mapGetters('project', ['styleDefault', 'styles', 'panoramaGroups', 'project', 'pages']),
    ...mapGetters('panoramas', ['panoramas']),
    currentPanoramaGroupName() {
      const id = +this.$route.params.id;
      const pages = this.pages || [];
      const pageById = pages.find(p => p && +p.id === id);
      if (pageById && pageById.label) {
        return this.$t ? this.$t(pageById.label) : pageById.label;
      }
      return this.$t ? this.$t('Panoramas') : 'Panoramas';
    },
  },
  beforeRouteEnter(to, from, next) {
    const lang = store.getters['project/languageDefault'];

    store
      .dispatch('panoramas/load', { order: to.params.order, lang: lang.iso })
      .then(({ data: panoramas }) => {
        next(undefined);
      });
  },
  methods: {
    generateRoute,
    getCdn(source) {
      return cdnUrl(source);
    },
  },
};
</script>
<style scoped>
.pano-link-wrapper {
  position: relative;
  max-width: 960px;
  padding: 15px 0;
}

.pano-link-wrapper img {
  display: block;
  max-width: 960px;
  max-height: 960px;
}

@media screen and (max-width: 960px) {
  .pano-link-wrapper img {
    width: 100%;
  }
}

.pano-link-description {
  position: absolute;
  bottom: 5px;
  left: 5px;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 5px 10px 0 10px;
  margin-left: 14px;
  margin-bottom: 20px;
  color: initial;
}

.pano-link-description {
  color: initial;
}
</style>

